import React, {useEffect, useMemo, useState, useRef} from "react";
import useLatLng from "../../hooks/uselatlng/uselatlng";
import {Button} from "react-bootstrap";
import "./main.css";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import {toast} from "react-toastify";
import Speed from "../InternetSpeed/Speed";
import Loader from "../../Loader/Loader";
import useDistanceFromSites from "../../hooks/currentlocation/useSiteDistance";
import DropDownInput from "../Input/dropDownInput/dropDownInput";
import localStorage from "redux-persist/es/storage";
import LastActivityModal from "../Parking/Activity/LastActivityModal/lastActivityModal";
import ModalPop from "../modal/modal";
import FailedModal from "../CustomModal/Failed";
import { useHistory } from 'react-router-dom';
import Config from "../../service/Config/config";
import callWebService, {callTypes} from "../../../src/service/Networks/network.js";
import HtmlFailedModal from "../CustomModal/htmlFailedModal.js";
import geocode, {appendLocationInImage} from "../Geocode";

const DistanceCalculator = ({
  moduleType,
  isMapShow = true,
  calculateDistance,
  checkInText = "Check In",
  checkoutId,
  moduleId = "",
  activityId = "",
  documentUploadUrlPublic = () => {},
  documentUrlDataPublic = [],
  showSelfie = true,
  attendanceResponse = [],
  accountId = "",
  module_name = "",
  isPendingActivityCheckRequired = true,
  locationLatAndLng = "",
  hideCheckButton = false,
  distance = "",
  leadId = 0,
  dealerId = "",
  lat = "",
  long = "",
  opportunity_id = "",
  allowCheckOutOnMissingMeeting = false,
  onSuccess = "",
  onError = "",
  valetProjectId = "",
  showTaggedAlong = false,
  taggedAlongList = [],
  projectType = 0,
  pjpId = '',
  deviceId = '',
  deviceIdCheck = false,
}) => {
  let markers = [];
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    formatted_address: null,
    lat: 0,
    lng: 0,
  });
  const [isAllow, setIsAllow] = useState(false);
  const canvasRef = useRef(null);
  const islatlng = useLatLng();
  const [comments, setComments] = useState("");
  const [selfie, setSelfie] = useState("");
  const [selfieUrl, setSelfieUrl] = useState("");
  const [retake, setRetake] = useState(true);
  const [roleId, setRoleId] = useState("");
  const [resetSelfie, setResetSelfie] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [taggedAlongValue, setTaggedAlongValue] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [currentLat, setCurrentLat] = useState('')
  const [currentLong, setCurrentLong] = useState('')
  const [showLastActivities,setShowLastActivities]=useState(false)
  const [redirectUrl,setRedirectUrl]=useState('');
  const [previousActivities,setPreviousActivities]=useState([]);
  const [showPendingRatingActivity,setShowPendingRatingActivity]=useState(false)
  const [pendingActivitiesText,setPendingActivitiesText]=useState('');
  const history = useHistory();

  // const [pendingRatingActivity,setPendingRatingActivity]=useState(null);

    console.log("islatlng", islatlng)
    const dis = useDistanceFromSites(lat, long)
    // // console.log(distance+" "+lat+" "+long)
    // // distance = dis?.distance_in_km !== undefined ? " " + parseFloat(dis?.distance_in_km).toFixed(2) + " meter away from site" : distance
    useEffect(() => {
        if(dis?.distance_in_km !== undefined){
            console.log("recalculate distance "+JSON.stringify(dis))
            distance = " " + parseFloat(dis?.distance_in_km).toFixed(2) * 1000 + " meter away from site"
        }
    }, [dis])

    useEffect(() => {
        const fetchData = async () => {
            try {
              const token = await localStorage.getItem('token');
              const base_url = process.env.REACT_APP_API_URL;
              const moduleType = await localStorage?.getItem('module_type')||'';
              const response = await callWebService(callTypes.get, '', `${Config?.getPreviousActivities}?opportunity_id=${opportunity_id}&account_id=${accountId}&lead_id=${leadId}&dealer_id=${dealerId}&valet_project_id=${valetProjectId}&based_on_assign_to=${true}&module_type=${moduleType}`);
                if (response !== null && response?.data !== null && response?.data?.response !== null) {
                  const responseData = response?.data?.response?.data;
                  if (responseData?.has_pending_activity == true) {
                    setShowPendingRatingActivity(true);
                    setShowLastActivities(false);
                    setPendingActivitiesText(responseData?.pending_activities_text);
                  } else if (moduleType !== 'Fasttag Toll' && responseData?.activities?.length > 0) {
                    setPreviousActivities(responseData.activities);
                    setShowLastActivities(true);
                    setShowPendingRatingActivity(false);
                  } else {
                    setShowPendingRatingActivity(false);
                    setShowLastActivities(false);
                  }
                }
            }catch(error) {
              setIsLoading(false)
              console.error('Failed to fetch locations:', error);
              return;
            }
        };
        setIsLoading(true)
        
        if(checkInText == "Check In"){
            fetchData()
        }
        setIsLoading(false)

    },[checkInText, opportunity_id,accountId,leadId])

    useEffect(() => {
        setCurrentLat(islatlng?.lat);
        setCurrentLong(islatlng?.lng);
  },[islatlng?.lat, islatlng?.lng])

    useEffect(() => {
      if (selfie !== '' && canvasRef.current) {
          const canvas = canvasRef.current;
          (async () => {
              setIsLoading(true);
              const address = await geocode(islatlng?.lat, islatlng?.lng);
              appendLocationInImage(islatlng?.lat, islatlng?.lng, address ,canvas, selfie, documentUploadUrlPublic);
              setIsLoading(false);
          })();
      }
  }, [selfie]);

  useEffect(() => {
    setRoleId(window.localStorage.role_id);
    if (checkInText === "Check out") {
      setTimeout(() => {
        setSelfieUrl("");
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (documentUrlDataPublic?.file_url !== undefined) {
      setSelfieUrl(documentUrlDataPublic?.file_url);
    }
  }, [documentUrlDataPublic]);

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
    }, [islatlng]);

    const handleDeviceCheck = async (deviceId, id, activityId) => {
      let  device_id = '';
      if(window.localStorage.device_id){
       device_id = window.localStorage.device_id;
      } else {
        device_id = deviceId;
      }

      const base_url = process.env.REACT_APP_API_URL;
      var config = {
        headers: {
          "Content-Type": "application/json",
          "Authorization": await localStorage.getItem("token")
        }};
      if(!deviceIdCheck){
        return true;
      }

      const response = await callWebService(callTypes.get,'',
          `${Config?.checkDeviceId}?device_id=${device_id}&id=${id}&activity_id=${activityId}`
      );

      if (response.data.status === true) {
        return response?.data?.response?.data
      }
    }

  const memoizedCameraComponent = useMemo(() => {
    return (
        <Camera
            idealFacingMode={"user"}
            idealResolution={{ width: 600, height: 480 }}
            onTakePhoto={(dataUri) => {
              setSelfie(dataUri);
              setRetake(false);
            }}
        />
    );
  }, [retake]);
  useEffect(() => {
    // Function to check window width and update state
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Define the breakpoint for mobile
    };

    // Initial check on component mount
    handleResize();

    // Add event listener to detect window resize
    window.addEventListener('resize', handleResize);

    // Cleanup on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const handleSubmitData = async () => {
        if (isAllow) {
            toast.error("In order to submit the form you need to allow the location first");
            return false
        }

    const data = {
      lat: islatlng?.lat,
      long: islatlng?.lng,
      module_type: moduleType,
    };

    data["comments"] = comments;
    data["check_type"] = "in";
    data["id"] = checkoutId;
    data["selfie"] = selfieUrl;
    data["account_id"] = accountId;
    data["opportunity_id"] = opportunity_id;
    data["device_id"] = null;
    if(window.localStorage.device_id || deviceId){
      data["device_id"] = window.localStorage.device_id ?? deviceId;
    }

    if(pjpId){
      data["pjp_id"] = pjpId;
    }

    data["lead_id"] = leadId;
    data["allow_check_out_on_missing_meeting"] = allowCheckOutOnMissingMeeting;
    // data['lead_id'] = leadId
    data["is_pending_activity_check_required"] = isPendingActivityCheckRequired;
    if (
      selfieUrl === "" &&
      checkInText === "Check In" &&
      parseInt(roleId) !== 42
    ) {
      toast.error("Please take selfie");
      return false;
    }

    // data['selfie'] = selfie
    if (checkInText === "Check out") {
      data["check_type"] = "out";
      const response = await handleDeviceCheck(deviceId, checkoutId, activityId);
      if(!response){
        toast.error("Check in device and check out device must be same");
        return false;
      }
    }

    data['device_info'] = null;
    if(window.localStorage?.webview){
         data['device_info'] = {
            'brand_name': window.localStorage?.brand_name,
            'model_name': window.localStorage?.model_name,
            'device_name': window.localStorage?.device_name,
            'device_os': window.localStorage?.device_os,
            'device_os_version': window.localStorage?.device_os_version,
        }
    }
    if (moduleType === "Dealer") {
      data["dealer_id"] = moduleId;
    }

    if (activityId !== "") {
      data["activity_id"] = activityId;
    }

    if(moduleType === "valet"){
      data['valet_project_id'] = valetProjectId;
    }

    if (
      data["lat"] === null &&
      locationLatAndLng?.lat !== undefined &&
      locationLatAndLng?.lat !== null
    ) {
      data["lat"] = locationLatAndLng?.lat;
      data["long"] = locationLatAndLng?.lng;
    }

    if (data["lat"] === null || data["long"] === null) {
      toast.error("Please enable your location");
      return false;
    }

    if (module_name !== "") {
      data["module_name"] = module_name;
    }

    if(taggedAlongValue.length > 0){
      data['tagged_along'] = taggedAlongValue.map(value => value.id);
    }
    // console.log("datadata" +JSON.stringify(data))
    // return false;
      setIsLoading(true)
      let res = await calculateDistance(data);
      setSelfie(false)
      setIsLoading(false)
    if (!isMapShow) {
      window.location.reload();
    }
  };

  const handleModalClose = () => {
    setIsLoading(true)        
    setShowLastActivities(false);
    setIsLoading(false)
  };

  const handlePendingActivityModalClose = () => {
    setIsLoading(true)
    setShowPendingRatingActivity(false)
    history.goBack()
    setIsLoading(false)
  };

  // function renderMarkers(map, maps) {
  //     markers = [ // Just an example this should probably be in your state or props.
  //         {
  //             title: "eng site",
  //             position: {lat: Number(islatlng?.lat), lng: Number(islatlng?.lng)}
  //         }
  //     ];
  //
  //     markers.map((marker1, index) => (
  //         new maps.Marker({
  //             key: index,
  //             position: marker1.position,
  //             name: marker1.name,
  //             map,
  //             title: (marker1.title == 'eng site') ? 'You are here!' : 'Site',
  //             icon: {url: (marker1.title == 'eng site') ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png" : "http://maps.google.com/mapfiles/ms/icons/red-dot.png"}
  //         })
  //     ))
  // }

  return (
    <>
    {showPendingRatingActivity ? (
          <HtmlFailedModal
              isOpen = {showPendingRatingActivity}
              msg={pendingActivitiesText}
              handleModalHide={
                handlePendingActivityModalClose
              }
              >
            
          </HtmlFailedModal>
        ):(
          <>
        <Loader isLoading={isLoading} />
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.4.1/css/all.css"
          integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700"
          rel="stylesheet"
        ></link>
        {/* {console.log("showPendingRatingActivity",showPendingRatingActivity)}
        {console.log("pendingRatingActivity",pendingRatingActivity)} */}
        {showPendingRatingActivity &&
          <HtmlFailedModal
              isOpen = {showPendingRatingActivity}
              msg={pendingActivitiesText}
              handleModalHide={
                handlePendingActivityModalClose
              }
              >
            
          </HtmlFailedModal>
        }
        {showLastActivities && previousActivities && previousActivities.length>0 &&
            <LastActivityModal
                title={`Last Activity's MOM`}
                activities={previousActivities.map(act => {
                    // Extracting product and service details
                    const product = act.meta_data?.[0]?.product?.[0]?.name
                    const serviceDetails = act.meta_data?.[0]?.service_details?.find(service => service.selected);
                    const solutionDetails = act.meta_data?.[0]?.solution_details?.find(solution => solution.selected);
                    const formattedReason = Array.isArray(act?.reason)
                    ? act?.reason?.[0]?.reason
                    : act?.reason;
                    return {
                        activity_type:act.activity_type,
                        project_type_name:act.project_type_name,
                        assigned_to_name:act.assigned_to_name,
                        mom: act.meta_data?.[0]?.MOM||act.meta_data?.[0]?.mom,
                        introduction: act.meta_data?.[0]?.Introduction,
                        meetingType: act.meta_data?.[0]?.Meeting_Type,
                        remark: act.meta_data?.[0]?.remark,
                        tagged_along_name: act?.tagged_along_name,
                        activity_date: act?.activity_date,
                        description: act?.description,
                        meeting_outcome: act?.meeting_outcome?.[0]?.Outcome,
                        purpose_of_visit: act?.purpose_of_visit?.[0]?.visit_purpose,
                        reason: formattedReason,
                        product: product,
                        serviceId: serviceDetails?.id,
                        solutionId: solutionDetails?.id,
                        valet_client_mom:act?.meta_data?.[0]?.Client_Alignment?.[0]?.Client_Mom,
                        sub_activity_type:act?.sub_activity_type,
                        comment:act?.meta_data?.[0]?.Comment,
                        internal_mom:act?.meta_data?.[0]?.internal_mom,
                        payment_collection_mom: act?.meta_data?.[0]?.payment_collection_details?.[0]?.payment_collection_mom,
                        relationship_meeting_mom:act?.meta_data?.[0]?.relationship_meeting_details?.[0]?.relationship_meeting_mom,
                        meeting_mom:act?.meta_data?.[0]?.Client_Alignment?.[0]?.Meeting_MoM
                    };
                })}
                show={showLastActivities}
                handleModalHide={() => {
                    handleModalClose();
                    // setOpenCheckIn(true)
                }}
            />
        }
        <div className="col-12"><><h3 style={{"color":"#000000"}}>{checkInText}
        <div style={{"float":"right"}}><small>{dealerId && (
                  <>
                    Dealer : {dealerId}
                  </>
                )}
                {leadId !== "" && leadId !== 0 && (
                  <>
                    Lead : {leadId}
                  </>
                )}
                </small>
                </div>
          </h3></></div>
        <form className="attForm" style={{"margin-top":"auto"}}>
          <div className="row pointer-where-are-you">

            <div className="col-m-6">
              {/*<Speed />*/}
              {/*<img*/}
              {/*    src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"/> :*/}
              <p className="text-bold text-warning">{distance}</p>
              <div style={{ color: "dodgerblue" }}>
                {lat && (
                  <>
                    Site Location : {`${lat} , ${long}`}
                  </>
                )}

              </div>
              Your Location : {`${currentLat} , ${currentLong}`}
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-12">
              {showSelfie && parseInt(roleId) !== 42 && (
                <>
                  <div className="col-12">
                    <div className="map">
                      {/*google-map*/}
                      <div className="">
                        {/*{(mapLocation && mapLocation.lat &&*/}
                        {/*    <GoogleMapReact*/}
                        {/*        bootstrapURLKeys={{key: 'AIzaSyBlmRvuUm34c6KzlQ3-HrXJJY0WoNPYV8Y'}}*/}
                        {/*        defaultCenter={mapLocation}*/}
                        {/*        defaultZoom={15}*/}
                        {/*        yesIWantToUseGoogleMapApiInternals*/}
                        {/*        onGoogleApiLoaded={({map, maps}) => renderMarkers(map, maps)}*/}
                        {/*    >*/}
                        {/*    </GoogleMapReact>*/}
                        {/*)}*/}
                        <canvas
                            ref={canvasRef}
                            width="100%"
                            height="520"
                            style={{ display: 'none', border: '1px solid black', marginTop: '20px' }}
                        ></canvas>
                        {selfieUrl !== "" ? (
                            <img style={{width:"100%"}} src={`${selfieUrl}`} />
                        ) : (
                            retake && memoizedCameraComponent
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {checkInText === 'Check In' && (parseInt(projectType) === 2 || parseInt(projectType) === 1 || parseInt(projectType) === 3) && showTaggedAlong &&
                <div className="col-sm-12 col-md-12 mtk-075 float-field mb-4">
                  <label>Tag Along </label>
                  <DropDownInput
                      data={taggedAlongList}
                      label={' '}
                      getIdValue={(val) => {
                        setTaggedAlongValue(val)
                      }}
                      multipule={true}
                      hideLabel={true}
                      required={true}
                  />
                </div>
            }

            <div className="col-12">
              <textarea
                className="form-control form-control-user"
                placeholder=" Description"
                onChange={(e) => {
                  setComments(e.target.value);
                }}
                id="validationCustom01"
                rows="4"
                cols="50"
              />
              <label className="large-label float-lb">{/*Description*/}</label>
            </div>
            {isMobile ?
            <div className="col-3 d-flex">
            {!hideCheckButton && (
              <Button className="btn-sm" onClick={() => handleSubmitData()}>
                {"Submit"}
              </Button>
            )}
            {showSelfie && parseInt(roleId) !== 42 && (
                <Button
                  className="btn-sm float-right"
                  style={{ marginLeft: "36%" }}
                  onClick={() => {
                    setRetake(true);
                    setSelfieUrl("");
                    setSelfie("");
                  }}
                >
                  {"Retake"}
                </Button>
              )}
            </div>

            :
            <div className="col-12" style={{"color" : "red"}}>Checkin is disable on desktop mode</div>
            }

          </div>
        </form>
        </>
      )}
    </>
  );
};

export default DistanceCalculator;
